import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  MenuItem,
  Tabs,
  Tab,
  Button,
  Input,
  IconButton,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  InputLabel,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { Edit, Save, Delete, Cancel, Add } from "@mui/icons-material";
import "./consumer-module.css";
import { DataGrid } from "@mui/x-data-grid";
import { useConsumerApi } from "../../../../hooks/useConsumerApi";
import { handleFieldChange } from "../../../../utils/handleFieldChange";
import { countries } from "../../../../utils/country";
import { useNotificationContext } from "../../../../contextProviders/NotificationProvider";
import { sanitizeInput } from "../../../../utils/inputSanitizer";
import { useClientsApi } from "../../../../hooks/useClientsApi";
import { formatDateTime ,isBeforeMinDate} from "../../../../utils/formatDateTime";

const paginationModel = { page: 0, pageSize: 10 };

function TabPanel({ children, value, index }) {
  return (
    <div style={{ display: value === index ? "block" : "none", width: "100%" }}>
      <Box sx={{ p: 2 }}>{children}</Box>
    </div>
  );
}

export default function ConsumerTabsComponent({ consumer, onBack }) {
  const { loading: clientLoading, clients, fetchClients } = useClientsApi();

  const { showNotification } = useNotificationContext();
  const [errors, setErrors] = useState({});

      // textarea state
     // saved message for parent / widget
  // const safeMessage = sanitizeInput(message); // sanitized message

  const [tab, setTab] = useState(0);
  const [form, setForm] = useState({
    id: consumer.id,
    name: "",
    client: "",
    email: "",
    telephone: "",
    twoFactor: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    postcode: "",
    country: "GB",
    dob: "",
  });
 
 
  const [phoneCode, setPhoneCode] = useState(
    countries.find((c) => c.code === form.country)?.phoneCode || "+44"
  );

  useEffect(() => {
    const selected = countries.find((c) => c.code === form.country);
    setPhoneCode(selected ? selected.phoneCode : "+44");
  }, [form.country]);

  const goBack = () => {
    if (typeof onBack === "function") {
      onBack();
    } else {
      console.warn("onBack is not a function");
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  useEffect(() => {
    if (consumer) {
      let dobFormatted = "";
      if (consumer.dateOfBirth) {
        const dob = new Date(consumer.dateOfBirth);
        if (!isNaN(dob.getTime())) {
          dobFormatted = dob.toISOString().split("T")[0];
        } else {
          dobFormatted = consumer.dateOfBirth;
        }
      }

      let telephoneConsumer = consumer.telephone || consumer.phone || "";
      let countryCode = consumer.country || "GB";
      let phoneCode =
        countries.find((c) => c.code === countryCode)?.phoneCode || "+44";
      if (telephoneConsumer.startsWith(phoneCode)) {
        telephoneConsumer = telephoneConsumer.replace(phoneCode, "").trim();
      }

      setForm({
        id: consumer.id,
        name: consumer.firstName || "",
        client: consumer.clientId || "",
        email: consumer.email || "",
        telephone: telephoneConsumer,
        twoFactor: consumer.twoFactorMethod || "",
        address1: consumer.address || "",
        address2: consumer.address2 || "",
        city: consumer.townCity || "",
        state: consumer.countryState || "",
        postcode: consumer.postCode || "",
        country: consumer.country || "GB",
        dob: dobFormatted,
      });
    }
  }, [consumer]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };
  const [rows, setRows] = useState([]);
  const { getConversationWithCreditsByConsumerID, updateConsumer } =
    useConsumerApi();

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("dobinconsemre", form.dob);

    // Validate date of birth
    if (!form.dob) {
      setErrors((prev) => ({
        ...prev,
        dob: "Please enter a valid date of birth.",
      }));
      return;
    }

    if (
      form.dob.startsWith("0000") ||
      form.dob.startsWith("0001")
    ) {
      setErrors((prev) => ({
        ...prev,
        dob: "Please enter a valid date of birth.",
      }));
      return;
    }

    // Validate date using isBeforeMinDate
    if (isBeforeMinDate(form.dob)) {
      showNotification("Date of birth should be greater than 1900", "error");
      setErrors((prev) => ({
        ...prev,
        dob: "Date of birth should be greater than 1900",
      }));
      return;
    }

    // Validate date is not in the future

    const selectedCountry = countries.find((c) => c.code === form.country);
    const phoneCode = selectedCountry ? selectedCountry.phoneCode : "+44";
    const telephoneWithCode = form.telephone.startsWith(phoneCode)
      ? form.telephone
      : `${phoneCode}${form.telephone.trim()}`;

    const payload = {
      Id: form.id,
      Name: form.name,
      ClientId: form.client,
      Email: form.email,
      Phone: telephoneWithCode,
      TwoFactorMethod: form.twoFactor,
      Address: form.address1,
      Address2: form.address2,
      TownCity: form.city,
      CountryState: form.state,
      PostCode: form.postcode,
      Country: form.country,
      DateOfBirth: new Date(form.dob).toISOString(),
      IsActive: true,
    };

    try {
      const result = await updateConsumer(payload.Id, payload);
      console.log("Consumer updated:", result);
      showNotification("Consumer updated successfully", "success");
    } catch (error) {
      console.error("Update failed:", error);
      showNotification("Update failed. Please try again.", "error");
    }
  };

  const MessageHistory = [
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "date", headerName: "Date", width: 160 },
    { field: "method", headerName: "Method", width: 120 },
    { field: "direction", headerName: "Direction", width: 100 },
    { field: "content", headerName: "Content", width: 260 },
    { field: "operator", headerName: "Operator", width: 100 },
    { field: "replyTime", headerName: "Reply Time", width: 100 },
    { field: "creditBefore", headerName: "Credit Before", width: 120 },
    { field: "creditAfter", headerName: "Credit After", width: 120 },
  ];

  useEffect(() => {
    const fetchMessages = async () => {
      if (!consumer?.id) return;

      const data = await getConversationWithCreditsByConsumerID(consumer.id);
      if (!data || !data.data) return;

      const transformed = data.data.map((msg) => ({
        id: msg.messageId,
        conversationId: msg.conversationId,
        createdAt: new Date(msg.createdAt),
        date: formatDateTime(msg.createdAt),
        method: "Webchat",
        direction: msg.direction === 0 ? "Inbound" : "Outbound",
        content: msg.body,
        operator: msg.senderName || "—",
        replyTime: null,
        creditBefore: msg.creditBalanceBefore ?? "—",
        creditAfter: msg.creditBalanceAfter ?? "—",
      }));

      transformed.forEach((msg, index) => {
        if (msg.direction === "Inbound") {
          const reply = transformed.find(
            (m, i) =>
              i > index &&
              m.conversationId === msg.conversationId &&
              m.direction === "Outbound"
          );

          if (reply) {
            const diffMs = reply.createdAt - msg.createdAt;
            const diffMin = Math.floor(diffMs / 60000);
            const diffSec = Math.floor((diffMs % 60000) / 1000);
            msg.replyTime = `${diffMin}m ${diffSec}s`;
          } else {
            msg.replyTime = "—";
          }
        }
      });

      setRows(transformed);
    };

    fetchMessages();
  }, [consumer, getConversationWithCreditsByConsumerID]);

  // Tab 3 Credit Management
  const { updateCredits } = useConsumerApi();
  const [creditValue, setCreditValue] = useState(
    consumer.currentCreditBalance || 0
  );
  const [updating, setUpdating] = useState(false);

  const handleUpdateCredits = async () => {
    setUpdating(true);
    try {
      const result = await updateCredits(consumer.id, {
        consumerId: consumer.id,
        credits: creditValue,
        transactionReference: `ManualUpdate-${Date.now()}`,
        reason: "Manual credit update",
      });

      if (result?.success) {
        showNotification(
          `Credits updated successfully. New balance: ${result.data}`,
          "success"
        );
      } else {
        showNotification("An error occurred while updating credits", "error");
      }
    } catch (error) {
      console.error("Error updating credits:", error);
      alert("An error occurred while updating credits");
    } finally {
      setUpdating(false);
    }
  };

  const creditColumns = [
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "createdAt", headerName: "Date", width: 180 },
    { field: "delta", headerName: "Credits Change", type: "number", width: 150 },
    { field: "balanceAfter", headerName: "Balance After", type: "number", width: 150 },
    { field: "reason", headerName: "Reason", width: 150 },
    { field: "transactionReference", headerName: "Transaction Ref", width: 220 },
    { field: "notes", headerName: "Notes", width: 250 },
  ];

  const [creditRows, setCreditRows] = useState([]);
  const { getCreditLedger } = useConsumerApi();

  useEffect(() => {
    const fetchLedger = async () => {
      if (!consumer?.id) return;

      const data = await getCreditLedger(consumer.id, 20);
      if (!data) return;

      const transformed = data.data.map((entry) => ({
        id: entry.id,
        createdAt: formatDateTime(entry.createdAt),
        delta: entry.delta,
        balanceAfter: entry.balanceAfter,
        reason: entry.reason,
        transactionReference: entry.transactionReference,
        notes: entry.notes,
      }));

      setCreditRows(transformed);
    };

    fetchLedger();
  }, [consumer, getCreditLedger, updating]);

  // Notes Management
  const { getConsumerNotesByConsumerID, addNoteToConsumer, updateConsumerNote } =
    useConsumerApi();
  const [newNote, setNewNote] = useState("");
  const [notesData, setNotesData] = useState([]);
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [showNoteModal, setShowNoteModal] = useState(false);

  const handleCancel = () => {
    setNewNote("");
    setEditingNoteId(null);
  };

  const fetchNotes = async () => {
    const currentUser = JSON.parse(localStorage.getItem("user"));
    const currentUserName = currentUser?.name || "Unknown";

    if (!consumer?.id) return;

    const result = await getConsumerNotesByConsumerID(consumer.id);
    if (result && result.length > 0) {
      const formattedNotes = result.map((note) => {
        const isBeingEdited = note.id === editingNoteId;

        return {
          id: note.id,
          date: note.date || note.createdAt,
          content: note.content || note.note || "",
          role: note.role || "Operator",
          modifiedBy: isBeingEdited
            ? currentUser?.name || "Operator"
            : note.modifiedBy || note.role || "Operator",
          modifiedAt: isBeingEdited
            ? new Date().toISOString()
            : note.modifiedDate || note.updatedAt || note.date || note.createdAt,
        };
      });
      setNotesData(formattedNotes);
    } else {
      setNotesData([]);
    }
  };

  useEffect(() => {
    fetchNotes();
  }, [consumer, getConsumerNotesByConsumerID]);

  // Add or update note
  const handleAddNote = async () => {
    if (!newNote.trim() || !consumer) {
      showNotification("Please enter a note", "warning");
      return;
    }
    if (newNote.length > 160) {
      showNotification("Note must be 160 characters or less", "error");
      return;
    }

    const storedUser = JSON.parse(localStorage.getItem("user"));
    const exactContent = newNote;

    // If editing an existing note
    if (editingNoteId) {
      const originalNote = notesData.find((n) => n.id === editingNoteId);

      const updatePayload = {
        id: editingNoteId,
        consumerId: consumer.id,
        content: exactContent,
        date: originalNote?.date || new Date().toISOString(),
        role: originalNote?.role || storedUser?.name || storedUser?.role,
      };

  
      try {
        const result = await updateConsumerNote(
          consumer.id,
          editingNoteId,
          updatePayload
        );
        console.log("Update result:", result);
        
        if (result && !result.error) {
          showNotification("Note updated successfully", "success");
          setEditingNoteId(null);
          setNewNote("");
          fetchNotes();
        } else {
          showNotification(result?.error || "Failed to update note", "error");
        }
      } catch (err) {
        console.error("Update note error:", err);
        showNotification("Failed to update note", "error");
      }
      return;
    }

    // Adding new note
    const newEntry = {
      date: new Date().toISOString(),
      role: storedUser?.name || storedUser?.role,
      content: exactContent,
      consumerId: consumer.id,
    };

    const result = await addNoteToConsumer(consumer.id, newEntry);

    if (result && !result.error) {
      setNewNote("");
      showNotification("Note added successfully", "success");
      fetchNotes();
    } else {
      console.error("Failed to add note:", result?.error);
      showNotification("Failed to add note", "error");
    }
  };

  const columns = [
    {
      field: "content",
      headerName: "Note",
      width: 250,
      renderCell: (params) => (
        <Typography
          variant="caption"
          sx={{
            fontSize: "0.875rem",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "date",
      headerName: "Added Date",
      width: 120,
      renderCell: (params) => (
        <Typography variant="caption" sx={{ fontSize: "0.875rem" }}>
          {formatDateTime(params.row.date)}
        </Typography>
      ),
    },
    {
      field: "role",
      headerName: "Added By",
      width: 120,
      renderCell: (params) => (
        <Typography variant="caption" sx={{ fontSize: "0.875rem" }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "modifiedAt",
      headerName: "Modified Date",
      width: 120,
      renderCell: (params) => (
        <Typography variant="caption" sx={{ fontSize: "0.875rem" }}>
          {formatDateTime(params.row.modifiedAt) || "—"}
        </Typography>
      ),
    },
    {
      field: "modifiedBy",
      headerName: "Modified By",
      width: 120,
      renderCell: (params) => (
        <Typography variant="caption" sx={{ fontSize: "0.875rem" }}>
          {params.row.modifiedBy || "—"}
        </Typography>
      ),
    },
    {
      field: "actions",
      headerName: "Edit",
      width: 70,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          size="small"
          onClick={() => {
            setEditingNoteId(params.row.id);
            setNewNote(params.row.content);
          }}
          color="primary"
        >
          <Edit fontSize="small" />
        </IconButton>
      ),
    },
  ];

  const {
    getConsumerCustomFields,
    createConsumerCustomField,
    updateConsumerCustomField,
    deleteConsumerCustomField,
    
  } = useConsumerApi();
  const [fields, setFields] = useState([]);
  const [newField, setNewField] = useState({ key: "", value: "" });
  const [showAddField, setShowAddField] = useState(false);

  const handleCancelAdd = () => {
    setNewField({ key: "", value: "" });
    setShowAddField(false);
  };

  const exportToCSV = () => {
    if (!rows || rows.length === 0) {
      showNotification("No data available to export", "warning");
      return;
    }

    const headers = [
      "Date",
      "Method",
      "Direction",
      "Content",
      "Operator",
      "Reply Time",
      "Credit Before",
      "Credit After",
    ];

    const csvRows = rows.map((r) =>
      [
        r.date,
        r.method,
        r.direction,
        `"${r.content?.replace(/"/g, '""')}"`,
        r.operator,
        r.replyTime,
        r.creditBefore,
        r.creditAfter,
      ].join(",")
    );

    const csvContent = [headers.join(","), ...csvRows].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `MessageHistory_${consumer.id}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const fetchFields = async () => {
      const result = await getConsumerCustomFields(consumer.id);
      const editableFields = result.map((f) => ({
        id: f.id,
        key: f.fieldKey,
        value: f.fieldValue,
        isEditing: false,
      }));
      setFields(editableFields);
    };

    fetchFields();
  }, [consumer.id]);

 

  const handleFieldChangeKeyValue = (id, key, value) => {
    setFields((prev) =>
      prev.map((f) => (f.id === id ? { ...f, key, value } : f))
    );
  };

  const toggleEdit = (id, reset = false) => {
    setFields((prev) =>
      prev.map((f) => {
        if (f.id === id) {
          if (!f.isEditing) {
            return { ...f, isEditing: true, originalValue: f.value };
          } else {
            return {
              ...f,
              isEditing: false,
              value: reset ? f.originalValue : f.value,
              originalValue: undefined,
            };
          }
        }
        return f;
      })
    );
  };

  const handleSaveField = async (id) => {
    const field = fields.find((f) => f.id === id);
    await updateConsumerCustomField(id, {
      consumerId: consumer.id,
      fieldKey: field.key,
      fieldValue: field.value,
    });
    toggleEdit(id);
    showNotification("Custom field updated successfully", "success");
  };

  const handleDeleteField = async (id) => {
    await deleteConsumerCustomField(id);
    setFields((prev) => prev.filter((f) => f.id !== id));
    showNotification("Custom field deleted successfully", "success");
  };

  const exportCreditsToCSV = () => {
    if (!creditRows || creditRows.length === 0) {
      showNotification("No credit history available to export", "warning");
      return;
    }

    const headers = [
      "Date",
      "Credits Change",
      "Balance After",
      "Reason",
      "Transaction Ref",
      "Notes",
    ];

    const csvRows = creditRows.map((r) =>
      [
        r.createdAt,
        r.delta,
        r.balanceAfter,
        r.reason,
        `"${r.transactionReference}"`,
        `"${(r.notes || "").replace(/"/g, '""')}"`,
      ].join(",")
    );

    const csvContent = [headers.join(","), ...csvRows].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `CreditHistory_${consumer.id}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleAddField = async () => {
    if (!newField.key || !newField.value) {
      showNotification(
        "Please provide both key and value for the custom field",
        "warning"
      );
      return;
    }

    try {
      const result = await createConsumerCustomField(consumer.id, {
        consumerId: consumer.id,
        fieldKey: newField.key,
        fieldValue: newField.value,
      });

      if (result) {
        setFields((prev) => [
          ...prev,
          { ...newField, id: result.id, isEditing: false },
        ]);
        setNewField({ key: "", value: "" });
        showNotification("Custom field added successfully", "success");
      } else {
        showNotification("Failed to add custom field", "error");
      }
    } catch (error) {
      console.error("Error adding custom field:", error);
      showNotification(
        "An error occurred while adding the custom field",
        "error"
      );
    }
  };

  const exportNotesToCSV = () => {
    if (!notesData || notesData.length === 0) {
      showNotification("No notes available to export", "warning");
      return;
    }

    const headers = ["Date", "Note", "Added By", "Modified By", "Modified Time"];

    const csvRows = notesData.map((n) =>
      [
        formatDateTime(n.date),
        `"${(n.content || "").replace(/"/g, '""')}"`,
        n.role,
        n.modifiedBy || "—",
        formatDateTime(n.modifiedAt) || "—",
      ].join(",")
    );

    const csvContent = [headers.join(","), ...csvRows].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Notes_${consumer.id}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Typography
              variant="h4"
              component="h1"
              sx={{
                color: "var(--color-primary)",
                fontWeight: 700,
                marginBottom: 0,
                marginRight: 1,
              }}
            >
              CONSUMER
            </Typography>
            <div>
              <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
                {form.name}
              </Typography>
             <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
                  Available Credits: {(consumer.currentCreditBalance ?? 0).toLocaleString()}
             </Typography>
            </div>
          </div>
          <Button
            variant="outlined"
            onClick={goBack}
            sx={{
              color: "#fff",
              borderColor: "#635f5fff",
              backgroundColor: "#635f5fff",
              "&:hover": { backgroundColor: "#333", borderColor: "#333" },
            }}
          >
            Back to Consumer
          </Button>
        </div>

        <Paper sx={{ width: "100%" }}>
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              "& .MuiTab-root": {
                color: "#666",
                "&.Mui-selected": {
                  color: "var(--color-primary)",
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "var(--color-primary)",
              },
            }}
          >
            <Tab label="Details" />
            <Tab label="Activity" />
            <Tab label="Credits" />
            <Tab label="Notes" />
             
          </Tabs>

          {/* Tab 0: Details */}
          <TabPanel value={tab} index={0}>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#f8f9fa",
                minHeight: 320,
                position: "relative",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 20,
                  marginBottom: 20,
                  width: "100%",
                }}
              >
                <TextField
                  type="text"
                  label="Name"
                  name="name"
                  autoFocus={true}
                  required
                  value={form.name}
                  onChange={(e) =>
                    handleFieldChange(
                      "name",
                      sanitizeInput(e.target.value),
                      setForm,
                      setErrors
                    )
                  }
                  size="medium"
                  error={!!errors.name}
                  helperText={errors.name}
                  inputProps={{ maxLength: 30 }}
                  sx={{ width: "30%", minWidth: 180 }}
                />

                <TextField
                  select
                  label="Client"
                  name="clientid"
                  value={form.client}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    setForm((prev) => ({ ...prev, client: selectedId }));
                  }}
                  size="medium"
                  sx={{ width: "30%", minWidth: 180 }}
                  disabled={clientLoading}
                >
                  {clients.map((client) => (
                    <MenuItem key={client.id} value={client.id.toString()}>
                      {client.name}
                    </MenuItem>
                  ))}
                </TextField>
    <TextField
  type="date"
  label="Date of Birth"
  name="dob"
  required
  value={form.dob}
  onChange={(e) => {
    handleChange("dob", e.target.value);
    setErrors((prev) => ({ ...prev, dob: "" }));
  }}
  size="medium"
  sx={{ width: "30%", minWidth: 180 }}
  inputProps={{
    min: "1900-01-01",
    max: (() => {
      const d = new Date();
        // d.setDate(d.getDate() - 1); 
      return d.toISOString().split("T")[0];
    })(),
  }}
  InputLabelProps={{ shrink: true }}
    error={!!form.dob && isBeforeMinDate(form.dob)}
  helperText={
     form.dob && isBeforeMinDate(form.dob)
      ? "Value must be 01-01-1900 or later."
      : "Date must be after 01/01/1900"
      
  }
/>
           
  

                <TextField
                  type="email"
                  label="Email"
                  name="email"
                  required
                  value={form.email}
                  onChange={(e) =>
                    handleFieldChange("email", e.target.value, setForm, setErrors)
                  }
                  error={!!errors.email}
                  helperText={errors.email}
                  size="medium"
                  inputProps={{ maxLength: 50 }}
                  sx={{ width: "30%", minWidth: 180 }}
                />

                <TextField
                  label="Telephone"
                  name="telephone"
                  size="medium"
                  required
                  value={form.telephone}
                  onChange={(e) =>
                    handleChange("telephone", e.target.value.replace(/[^0-9]/g, ""))
                  }
                  sx={{ width: "30%", minWidth: 180 }}
                  inputProps={{ maxLength: 15 }}
                  InputProps={{
                    startAdornment: (
                      <Box
                        sx={{
                          minWidth: 72,
                          mr: 1,
                          borderRight: "2px solid #E9E9E9",
                          pr: 1,
                        }}
                      >
                        {phoneCode}
                      </Box>
                    ),
                  }}
                />

                <TextField
                  select
                  label="2 Factor Method"
                  name="twoFactor"
                  value={form.twoFactor}
                  onChange={(e) => handleChange("twoFactor", e.target.value)}
                  size="medium"
                  sx={{ width: "30%", minWidth: 180 }}
                >
                  <MenuItem value="app">Authenticator App</MenuItem>
                  <MenuItem value="email">Email</MenuItem>
                </TextField>
              </Box>

              <Box
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 20,
                  marginBottom: 20,
                  width: "100%",
                }}
              >
                <TextField
                  type="text"
                  label="Address"
                  name="address1"
                  required
                  value={form.address1}
                  onChange={(e) =>
                    handleFieldChange("address1", e.target.value, setForm, setErrors)
                  }
                  error={!!errors.address1}
                  helperText={errors.address1}
                  size="medium"
                  inputProps={{ maxLength: 30 }}
                  sx={{ width: "30%", minWidth: 180 }}
                />

                <TextField
                  type="text"
                  label="Address 2"
                  name="address2"
                  value={form.address2}
                  onChange={(e) => handleChange("address2", e.target.value)}
                  size="medium"
                  inputProps={{ maxLength: 30 }}
                  sx={{ width: "30%", minWidth: 180 }}
                />
              </Box>

              <Box
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 20,
                  marginBottom: 20,
                  width: "100%",
                }}
              >
                <TextField
                  type="text"
                  label="Town/City"
                  name="city"
                  required
                  value={form.city}
                  onChange={(e) =>
                    handleFieldChange("city", e.target.value, setForm, setErrors)
                  }
                  error={!!errors.city}
                  helperText={errors.city}
                  size="medium"
                  inputProps={{ maxLength: 30 }}
                  sx={{ width: "30%", minWidth: 180 }}
                />

                <TextField
                  type="text"
                  label="County/State"
                  name="state"
                  required
                  value={form.state}
                  onChange={(e) =>
                    handleFieldChange("state", e.target.value, setForm, setErrors)
                  }
                  error={!!errors.state}
                  size="medium"
                  inputProps={{ maxLength: 30 }}
                  sx={{ width: "30%", minWidth: 180 }}
                />
              </Box>

              <Box
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 20,
                  marginBottom: 20,
                  width: "100%",
                }}
              >
                <TextField
                  type="text"
                  label="PostCode/Zip Code"
                  name="postcode"
                  required
                  value={form.postcode}
                  onChange={(e) => {
                    handleFieldChange("postcode", e.target.value, setForm, setErrors);
                  }}
                  error={!!errors.postcode}
                  helperText={errors.postcode}
                  inputProps={{ maxLength: 10 }}
                  sx={{ width: "30%", minWidth: 180 }}
                />

                <TextField
                  select
                  label="Country"
                  name="country"
                  value={form.country}
                  onChange={(e) => handleChange("country", e.target.value)}
                  size="medium"
                  sx={{ width: "30%", minWidth: 180 }}
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        style: { maxHeight: 220 },
                      },
                    },
                  }}
                >
                  {countries.map((country) => (
                    <MenuItem key={country.code} value={country.code}>
                      {country.name}
                    </MenuItem>
                  ))}
                </TextField>

                <Button
  type="submit"
  variant="contained"
  color="primary"
  onClick={handleSubmit}
  disabled={Object.values(errors).some((msg) => msg)}
  sx={{
    height: 40,
    width: "30%",
    minWidth: 180,
    backgroundColor: "primary",
    "&:hover": {
      backgroundColor: "primary",
    },
    "&:active": {
      backgroundColor: "primary",
    },
    "&:focus": {
      backgroundColor: "primary",
    },
    "&.Mui-disabled": {
      backgroundColor: "grey.400",
      color: "white",
    },
  }}
>
  Submit Changes
</Button>

              </Box>
            </Box>
          </TabPanel>
          

        
          <TabPanel value={tab} index={1}>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#f8f9fa",
                minHeight: 400,
                position: "relative",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                  Message History
                </Typography>

                <Button
                  variant="outlined"
                  sx={{
                    color: "var(--color-primary)",
                    borderColor: "var(--color-primary)",
                    "&:hover": { borderColor: "var(--color-secondary)" },
                  }}
                  onClick={exportToCSV}
                >
                  Export CSV
                </Button>
              </Box>

              <Paper
                sx={{
                  height: 480,
                  width: "100%",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              >
                <DataGrid
                  rows={rows}
                  columns={MessageHistory}
                  rowHeight={36}
                  initialState={{
                    columns: {
                      columnVisibilityModel: { id: false },
                    },
                    pagination: { paginationModel },
                  }}
                  pageSizeOptions={[10, 20, 50]}
                  disableRowSelectionOnClick
                  sx={{
                    border: 0,
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontSize: "14px",
                      fontWeight: "bold",
                    },
                  }}
                />
              </Paper>
            </Box>
          </TabPanel>

          {/* Tab 2: Credits */}
          <TabPanel value={tab} index={2}>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#f8f9fa",
                minHeight: 400,
                position: "relative",
              }}
            >
              <Typography variant="body1" sx={{ mb: 2, fontWeight: 700 }}>
                Current Credits: {consumer.currentCreditBalance}
              </Typography>
              <Box sx={{ mb: 3 }}>
                <Input
                  type="number"
                  value={creditValue}
                  onChange={(e) => setCreditValue(e.target.value)}
                  placeholder="Current Credits"
                  inputProps={{ min: 0, step: 10 }}
                  sx={{ width: 200, mr: 2, p: "4px 8px 0px 8px" }}
                />
                <Button
                  variant="contained"
                  onClick={handleUpdateCredits}
                  disabled={updating}
                  sx={{
                    color: "var(--color-white)",
                    backgroundColor: "var(--color-primary)",
                  }}
                >
                  {updating ? "Updating..." : "Update Credits"}
                </Button>
              </Box>

              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
              >
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                  Purchase History
                </Typography>

                <Button
                  variant="outlined"
                  sx={{
                    color: "var(--color-primary)",
                    borderColor: "var(--color-primary)",
                    "&:hover": { borderColor: "var(--color-secondary)" },
                  }}
                  onClick={exportCreditsToCSV}
                >
                  Export CSV
                </Button>
              </Box>

              <Paper
                sx={{
                  height: 480,
                  width: "100%",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              >
                <DataGrid
                  rows={creditRows}
                  columns={creditColumns}
                  rowHeight={36}
                  initialState={{
                    columns: {
                      columnVisibilityModel: { id: false },
                    },
                    pagination: { paginationModel },
                  }}
                  pageSizeOptions={[10, 20, 50]}
                  disableRowSelectionOnClick
                  sx={{
                    border: 0,
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontSize: "14px",
                      fontWeight: "bold",
                    },
                  }}
                />
              </Paper>
            </Box>
          </TabPanel>

          {/* Tab 3: Notes */}
          <TabPanel value={tab} index={3}>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#f8f9fa",
                minHeight: 400,
                position: "relative",
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                <Typography variant="body1" sx={{ fontWeight: 700, color: "var(--color-primary)" }}>
                  Custom Fields
                </Typography>
                <Button
                  variant="outlined"
                  onClick={() => setShowAddField(true)}
                  sx={{
                    borderColor: "var(--color-primary)",
                    color: "var(--color-secondary)",
                  }}
                >
                  Add Field
                </Button>
              </Box>

              <Paper sx={{ height: 200, overflow: "hidden", boxShadow: 2, mb: 4 }}>
                <DataGrid
                  rows={fields}
                  columns={[
                    {
                      field: "key",
                      headerName: "Key",
                      width: 100,
                      renderCell: (params) => (
                        <Typography variant="body2">
                          {params.row.key}
                        </Typography>
                      ),
                    },
                    {
                      field: "value",
                      headerName: "Value",
                      width: 120,
                      renderCell: (params) =>
                        params.row.isEditing ? (
                          <TextField
                            size="small"
                            value={params.row.value}
                            onChange={(e) =>
                              handleFieldChangeKeyValue(
                                params.row.id,
                                params.row.key,
                                e.target.value
                              )
                            }
                            onKeyDown={(e) => e.stopPropagation()}
                            required
                            inputProps={{ maxLength: 30 }}
                            sx={{ maxWidth: "120px" }}
                            variant="outlined"
                          />
                        ) : (
                          <Typography variant="body2">{params.row.value}</Typography>
                        ),
                    },
                    {
                      field: "actions",
                      headerName: "Actions",
                      sortable: false,
                      width: 120,
                      renderCell: (params) =>
                        params.row.isEditing ? (
                          <Box sx={{ display: "flex", gap: 0.5 }}>
                            <IconButton
                              size="small"
                              onClick={() => handleSaveField(params.row.id)}
                              color="primary"
                            >
                              <Save fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteField(params.row.id)}
                              color="error"
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => toggleEdit(params.row.id, true)}
                              color="default"
                            >
                              <Cancel fontSize="small" />
                            </IconButton>
                          </Box>
                        ) : (
                          <IconButton
                            size="small"
                            onClick={() => toggleEdit(params.row.id)}
                            color="primary"
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                        ),
                    },
                  ]}
                  hideFooter
                  pagination={false}
                  initialState={{
                    columns: {
                      columnVisibilityModel: { id: false },
                    },
                  }}
                  sx={{
                    border: 0,
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontWeight: "bold",
                    },
                    "& .MuiDataGrid-cell": {
                      py: 0.1,
                      display: "flex",
                      alignItems: "center !important",
                      justifyContent: "center",
                      minHeight: "auto !important",
                    },
                    "& .MuiDataGrid-columnHeader": {
                      justifyContent: "center",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                      backgroundColor: "white",
                    },
                    "& .MuiDataGrid-row": {
                      minHeight: "auto !important",
                    },
                  }}
                />
              </Paper>

              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
              >
                <Typography variant="body1" sx={{ fontWeight: 700, color: "var(--color-primary)" }}>
                  Notes
                </Typography>

                <Button
                  variant="outlined"
                  sx={{
                    color: "var(--color-primary)",
                    borderColor: "var(--color-primary)",
                    "&:hover": { borderColor: "var(--color-secondary)" },
                  }}
                  onClick={exportNotesToCSV}
                >
                  Export CSV
                </Button>
              </Box>

              <Paper
                sx={{
                  height: 290,
                  width: "100%",
                  borderRadius: 2,
                  boxShadow: 2,
                  mb: 4,
                }}
              >
                <DataGrid
                  rows={notesData}
                  columns={columns}
                  rowHeight={52}
                  onRowDoubleClick={(params) => {
                    setEditingNoteId(params.row.id);
                    setNewNote(params.row.content);
                  }}
                  getRowClassName={(params) =>
                    params.row.id === editingNoteId ? "editing-row" : ""
                  }
                  initialState={{
                    columns: {
                      columnVisibilityModel: { id: false },
                    },
                    pagination: { paginationModel: { pageSize: 5, page: 0 } },
                  }}
                  pageSizeOptions={[5, 10]}
                  disableRowSelectionOnClick
                  sx={{
                    border: 0,
                    height: 290,
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontSize: "14px",
                      fontWeight: "bold",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                      backgroundColor: "white",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      overflow: "auto",
                    },
                    "& .MuiDataGrid-row": {
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    },
                    "& .editing-row": {
                      backgroundColor: "#E3F2FD !important",
                      borderLeft: "4px solid #1976d2",
                    },
                  }}
                />
              </Paper>

              <Box sx={{ width: "100%", mt: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    width: "100%",
                  }}
                >
                  <TextField
                    variant="outlined"
                    placeholder={editingNoteId ? "Edit Note" : "Add New Note"}
                    multiline
                    minRows={1}
                    maxRows={2}
                    fullWidth
                    value={newNote}
                    onChange={(e) => {
                      setNewNote(e.target.value);
                    }}
                    inputProps={{
                      maxLength: 160,
                      autoCapitalize: "none",
                      autoCorrect: "off",
                      spellCheck: false,
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        minHeight: 42,
                        alignItems: "flex-start",
                        padding: "8px",
                      },
                    }}
                  />

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddNote}
                    disabled={!newNote.trim()}
                    sx={{
                      height: 42,
                      minWidth: 90,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {editingNoteId ? "Update" : "Add"}
                  </Button>

                  {editingNoteId && (
                    <Button
                      variant="outlined"
                      onClick={handleCancel}
                      sx={{
                        height: 42,
                        minWidth: 80,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Cancel
                    </Button>
                  )}
                </Box>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 0.5 }}>
                <Typography variant="caption" color="text.secondary">
                  {newNote.length}/160
                </Typography>
              </Box>
            </Box>
          </TabPanel>
        </Paper>

        {/* Add Custom Field Modal */}
        <Dialog
          open={showAddField}
          onClose={handleCancelAdd}
          PaperProps={{
            sx: {
              minWidth: 300,
              maxWidth: 450,
              p: 1,
              position: "relative",
            },
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleCancelAdd}
            size="small"
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "var(--color-primary)",
              zIndex: 1,
            }}
          >
            <Cancel fontSize="small" />
          </IconButton>

          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              pb: 0,
              mb: 1,
              pr: 4,
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              color="var(--color-primary)"
            >
              Add Custom Field
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ pt: 1 }}>
            <Box>
              <TextField
                fullWidth
                label="Field Key"
                value={newField.key}
                onChange={(e) =>
                  setNewField((prev) => ({ ...prev, key: e.target.value }))
                }
                inputProps={{ maxLength: 30 }}
                required
                sx={{ mb: 2, mt: 1 }}
                variant="outlined"
                size="medium"
              />
              <TextField
                fullWidth
                label="Field Value"
                value={newField.value}
                onChange={(e) =>
                  setNewField((prev) => ({
                    ...prev,
                    value: e.target.value,
                  }))
                }
                required
                inputProps={{ maxLength: 30 }}
                sx={{ mb: 2 }}
                variant="outlined"
                size="medium"
              />
              <Button
                fullWidth
                onClick={handleAddField}
                variant="contained"
                sx={{
                  backgroundColor: "var(--color-primary)",
                  "&:hover": { backgroundColor: "var(--color-secondary)" },
                }}
              >
                Add Field
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}